import React from 'react';
import bannerImage from 'assets/tb_logo_set_wallet_mobile.png';

import {
  BannerContainer,
  BannerImage,
} from './styled';

interface WalletAddressBannerProps {
  timeLeft: string;
}

const WalletAddressBanner: React.FC<WalletAddressBannerProps> = ({ timeLeft }) => {
  return (
    <BannerContainer>
      <BannerImage
        src={bannerImage}
        alt="Trading Battles"
      />
    </BannerContainer>
  );
};

export default WalletAddressBanner;
